import { gql } from "apollo-boost";

export const GET_PRODUCT_VARIANTS = gql`
  query ProductVariants(
    $where: ProductVariantWhereInput
    $orderBy: OrderByInput
    $skip: Int
    $limit: Int
  ) {
    productVariants(
      where: $where
      orderBy: $orderBy
      skip: $skip
      limit: $limit
    ) {
      total
      data {
        id
        barCode
        sort
        createdAt
        product {
          _id
          name
          isPublished
          brandName
          imageString
          category {
            id
            name
          }
        }
        image
        amount
        originAmount
        attributeValues {
          id
          value
          attribute {
            id
            name
          }
        }
        price
        originPrice
        currency
        commissionPlatforms {
          platform
          commissionType
          commissionValue
        }
        isUsingSalePage
      }
    }
  }
`;
